import { spotlightTheme } from './themes'

/**
 * @title spotlights
 * @description This file contains the spotlights for the PennyLane website.
 *
 * Directory:
 * Some helpful links for configuring spotlights:
 * ----------------------------------------------
 * @link Readme file://./README.md}
 * Documentation on how to configure spotlights.
 * @link Themes file://./themes.ts}
 * Themes are used to style the spotlights.
 * @link Templates file://./templates.md}
 * Templates are copy and paste-able code snippets that can be used to create new spotlights.
 */

export default {
  /**
   * @title home_page
   * @description
   * This spotlight is located on the home page of the website.
   * @link https://pennylane.ai/
   */
  home_page: {
    hidden: false,
    announcements: [
      // {
      // title: 'SURVEY CLOSES OCTOBER 29, 2026',
      // description:
      //   "Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
      // image:
      //   'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
      // image_right_aligned: false,
      // alt: '',
      // links: [
      //   {
      //     link_text: 'Complete the survey now!',
      //     link: 'https://bit.ly/4icIBkR',
      //   },
      //   {
      //     link_text: 'Read the blog post',
      //     link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
      //   },          
      // ],
      // colours: spotlightTheme.theme_2,
      // },
      {
      title: 'STREAMLINE YOUR QUANTUM WORKFLOW WITH PENNYLANE V0.45 & CATALYST V0.15',
      description:
        "Prepare application-focused states, customize your compilation pipeline, and deeply inspect your complete workflow.",
      image:
        'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/pennylane-spotlight-release-v0-45.png',
      image_right_aligned: true,
      alt: '',
      links: [
        {
          link_text: 'Read the blog post to learn how!',
          link: '/blog/2026/05/pennylane-release-0.45/',
        },
        // {
        //   link_text: 'Visit the PennyLane documentation',
        //   link: 'https://docs.pennylane.ai/en/stable/',
        // },          
      ],
      colours: spotlightTheme.theme_1,
      },
    ],
  },

  /**
   * @title education_page
   * @description This located on the education page of the website.
   * @link https://pennylane.ai/education/
   */
  education_page: {
    hidden: true,
    announcements: [      
      // {
      //title: 'SURVEY CLOSES OCTOBER 29, 2026',
      //description:
        //"Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
      //image:
        //'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
      //image_right_aligned: false,
      //alt: '',
      //links: [
        // {
          //link_text: 'Complete the survey now!',
          //link: 'https://bit.ly/4yIx0jR',
        //},
        //{
          //link_text: 'Read the blog post',
          //link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
        //},          
      //],
      //colours: spotlightTheme.theme_2,
      //},
      //{
      //title: 'PENNYLANE FUNDAMENTALS CODEBOOK MODULE',
      //description:
        //"Accelerate your quantum breakthroughs with PennyLane! Learn fundamental functions and practical applications.",
      //image:
        //'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_CodebookLaucnh_2024-04-30.png',
      //image_right_aligned: true,
      //alt: '',
      //links: [
        //{
          //link_text: 'Learn more',
          //link: '/codebook/pennylane-fundamentals',
        //},
      //],
      //colours: spotlightTheme.theme_1,
      //},
    ],
  },

  /**
   * @title learn_page
   * @description This spotlight is located on the learn page of the website.
   * @link https://pennylane.ai/learn/
   */
  learn_page: {
    hidden: false,
    announcements: [
      // {
      //title: 'SURVEY CLOSES OCTOBER 29, 2026',
        //description:
          //"Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        //image:
          //'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        //image_right_aligned: false,
        //alt: '',
        //links: [
          //{
            //link_text: 'Complete the survey now!',
            //link: 'https://bit.ly/3W2Dlcb',
          //},
          //{
            //link_text: 'Read the blog post',
            //link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
        //},          
      //],
      //colours: spotlightTheme.theme_2,
      //},
      {
      title: 'FRENCH CODEBOOK MODULES NOW AVAILABLE',
      description: "As a proudly Canadian quantum software framework, we offer five modules of the PennyLane Codebook in French.",
      image: 'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_CodebookLaucnh_2024-04-30.png',
      image_right_aligned: false,
      alt: '',
      links: [
        {
          link_text: 'Check them out!',
          link: '/codebook/introduction-to-quantum-computing/all-about-qubits/fr/',
        },
      ],
      colours: spotlightTheme.theme_2,
      },
    ],
  },

  /**
   * @title performance_page
   * @description This spotlight is located on the performance page of the website.
   * https://pennylane.ai/performance/
   */
  performance_page: {
    hidden: false,
    announcements: [
      //{
        //title: 'SURVEY CLOSES OCTOBER 29, 2026',
        //description:
          //"Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        //image:
          //'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        //image_right_aligned: false,
        //alt: '',
        //links: [
          //{
            //link_text: 'Complete the survey now!',
            //link: 'https://bit.ly/4jx8kXw',
          //},
          //{
            //link_text: 'Read the blog post',
            //link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
          //},          
        //],
        //colours: spotlightTheme.theme_1,
      //},
      {
        title: 'PENNYLANE IS FASTER THAN EVER',
        description:
          `Accelerate large-scale simulations on supercomputers and GPUs with PennyLane's latest research and insights.`,
        image:
          'https://assets.cloud.pennylane.ai/datasets/spotlight/Spotlight_HPC4UandMe.png',
        image_right_aligned: false,
        alt: '',
        links: [
          {
            link_text: 'Read the paper',
            link: 'https://arxiv.org/abs/2403.02512',
          },
          {
            link_text: 'Check out the blog',
            link: 'https://pennylane.ai/blog/2024/03/hpc-4-u-and-me/',
          },
        ],
        colours: spotlightTheme.theme_2,
      },
    ],
  },

  /**
   * @title install_page
   * @description This spotlight is located on the install page of the website.
   * @link https://pennylane.ai/install/
   */
  install_page: {
    hidden: true,
    announcements: [
      {
      title: 'SURVEY CLOSES OCTOBER 29, 2026',
        description:
          "Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        image_right_aligned: false,
        alt: '',
        links: [
          {
            link_text: 'Complete the survey now!',
            link: 'https://bit.ly/4z8qOTa',
          },
          {
            link_text: 'Read the blog post',
            link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
        },       
      ],
      colours: spotlightTheme.theme_2,
      },
    ],
  },

  /**
   * @title get_involved_page
   * @description This spotlight is located on the get involved page of the website.
   * @link https://pennylane.ai/get-involved/
   */
  get_involved_page: {
    hidden: true,
    announcements: [
      {
        title: 'SURVEY CLOSES OCTOBER 29, 2026',
        description:
          "Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        image_right_aligned: false,
        alt: '',
        links: [
          {
            link_text: 'Complete the survey now!',
            link: 'https://bit.ly/47BBFce',
          },
          {
            link_text: 'Read the blog post',
            link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
          },          
        ],
        colours: spotlightTheme.theme_2,
        },
    ],
  },

  /**
   * @title features_page
   * @description This spotlight is located on the features page of the website.
   * @link https://pennylane.ai/features/
   */
  features_page: {
    hidden: false,
    announcements: [
      {
        title: 'STREAMLINE YOUR QUANTUM WORKFLOW WITH PENNYLANE V0.45 & CATALYST V0.15',
          description:
            "Prepare application-focused states, customize your compilation pipeline, and deeply inspect your complete workflow.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/pennylane-spotlight-release-v0-45.png',
        image_right_aligned: true,
        alt: '',
        links: [
          {
            link_text: 'Read the blog post to learn how!',
            link: '/blog/2026/05/pennylane-release-0.45/',
          },     
        ],
        colours: spotlightTheme.theme_1,
      },
      //{
        //title: 'SURVEY CLOSES OCTOBER 29, 2026',
        //description:
          //"Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        //image:
          //'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        //image_right_aligned: false,
        //alt: '',
        //links: [
          //{
            //link_text: 'Complete the survey now!',
            //link: 'https://bit.ly/4shZjnn',
          //},
          //{
            //link_text: 'Read the blog post',
            //link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
          //},     
        //],
        //colours: spotlightTheme.theme_1,
      //},
    ],
  },

  /**
   * @title codebook_page
   * @description This spotlight is located on the codebook page of the website.
   * @link https://pennylane.ai/codebook/
   */
  codebook_page: {
    hidden: false,
    announcements: [  
      //{
        //title: 'SURVEY CLOSES OCTOBER 29, 2026',
        //description:
          //"Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        //image:
          //'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        //image_right_aligned: false,
        //alt: '',
        //links: [
          //{
            //link_text: 'Complete the survey now!',
            //link: 'https://bit.ly/4i0RVcJ',
          //},
          //{
            //link_text: 'Read the blog post',
            //link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
          //},          
        //],
        //colours: spotlightTheme.theme_2,
        //},
      {
        title: 'PENNYLANE FUNDAMENTALS CODEBOOK MODULE',
        description:
          "Accelerate your quantum breakthroughs with PennyLane! Learn fundamental functions and practical applications.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_CodebookLaucnh_2024-04-30.png',
        image_right_aligned: false,
        alt: '',
        links: [
          {
            link_text: 'Learn more',
            link: '/codebook/pennylane-fundamentals',
          },
        ],
        colours: spotlightTheme.theme_1,
      },
    ],
  },

  /**
   * @title challenges_page
   * @description This spotlight is located on the challenges page of the website.
   * @link https://pennylane.ai/challenges/
   */
  challenges_page: {
    hidden: true,
    announcements: [
      {
        title: 'SURVEY CLOSES OCTOBER 29, 2026',
        description:
          "Your voice matters. Take ~20 minutes to complete the survey and directly shape PennyLane’s roadmap and the future of open-source quantum software.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_PLSurvey_2024-03-05.png',
        image_right_aligned: false,
        alt: '',
        links: [
          {
            link_text: 'Complete the survey now!',
            link: 'https://bit.ly/4dTGJw1',
          },
          {
            link_text: 'Read the blog post',
            link: 'https://pennylane.ai/blog/2026/09/take-the-2026-UF-QOSS-Survey/',
          },          
        ],
        colours: spotlightTheme.theme_2,
        },
    ],
  },
  /**
   * @title research_page
   * @description This spotlight is located on the research page of the website.
   * @link https://pennylane.ai/research/
   */
  research_page: {
    hidden: false,
    announcements: [
      {
        title: '2000+ PAPERS POWERED BY PENNYLANE',
        description:
          "Accelerate your work with PennyLane and join 2,000+ innovators by featuring it in your next paper.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/pennylane-2000-citations-spotlight.png',
        image_right_aligned: true,
        alt: '',
        links: [
          {
            link_text: 'Use PennyLane in your next paper',
            link: 'https://docs.pennylane.ai/en/stable/#how-to-cite',
          }        
        ],
        colours: spotlightTheme.theme_1,
      },
      {
        title: 'QUANTUM COMPILATION',
        description:
          "Discover the essential techniques and clear guidance to start compiling large-scale, fault-tolerant quantum algorithms.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/Spotlight_CompilationLaunch.png',
        image_right_aligned: true,
        alt: '',
        links: [
          {
            link_text: 'Explore Quantum Compilation techniques',
            link: '/compilation',
          },
          // {
          //   link_text: 'Visit the Quantum Compilation wiki',
          //   link: '/compilation',
          // },          
        ],
        colours: spotlightTheme.theme_2,
      },
      {
        title: 'THE PENNYLANE GUIDE TO HAMILTONIAN SIMULATION',
        description:
          "Master Hamiltonian simulation, one of the most promising uses of quantum computing.",
        image:
          'https://assets.cloud.pennylane.ai/pennylane_website/spotlights/pennylane-spotlight-quantum-topics.png',
        image_right_aligned: false,
        alt: '',
        links: [
          {
            link_text: 'Check out the guide',
            link: '/topics/hamiltonian-simulation',
          },
          // {
          //   link_text: 'Check out the documentation',
          //   link: 'https://docs.pennylane.ai/en/stable/',
          // },
        ],
        colours: spotlightTheme.theme_1,
      }
    ],
  },
}
